import { Routes } from '@angular/router';
import { UsersListComponent } from './pages/users-list/users-list.component';
import { RoleGuard } from '../../../core/guards/auth.guard';
import { Permission } from '../../../core/models/role-permissions.models';

export default [
	{
		path: '',
		loadComponent: () => UsersListComponent,
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.USER_VIEW],
			comeback: 'panel',
		},
	},
] as Routes;
